import Receitas from '../assets/receitas.png';
import Ecommerce from '../assets/ecommerce.png';
import Carteira from '../assets/carteira.png';
import Back1 from '../assets/back1.png';
import Back2 from '../assets/back2.png';
import Back3 from '../assets/back3.png';

const frontendProjects = [
  {
    title: 'Aplicativo de receitas',
    image: Receitas,
    github: 'https://github.com/santanap2/16-Recipes-App',
    link: 'https://couple-food.netlify.app/',
  },

  {
    title: 'E-commerce',
    image: Ecommerce,
    github: 'https://github.com/santanap2/11-Project-FrontEnd-Online-Store',
    link: 'https://frontend-online-store-g2.netlify.app/',
  },

  {
    title: 'Carteira de gastos',
    image: Carteira,
    github: 'https://github.com/santanap2/13-Project-Trybewallet',
    link: 'https://trybewallet-psantana.netlify.app/',
  },
];

const backendProjects = [
  {
    title: 'API de um blog',
    image: Back1,
    github: 'https://github.com/santanap2/22-Project-Blogs-API',
  },

  {
    title: 'API de uma loja',
    image: Back2,
    github: 'https://github.com/santanap2/21-Project-Store-Manager',
  },

  {
    title: 'API de um ferreiro',
    image: Back3,
    github: 'https://github.com/santanap2/23-Project-Trybesmith',
  },
];

export {
  frontendProjects,
  backendProjects,
};